import { Controller, useFormContext } from "react-hook-form";
import { defaultProductItem, ProductItem, productItemFields } from "./types.ts";
import { styles } from "../../contracts/estimateStyle.tsx";
import { Stack } from "@mui/material";
import useProductItemForm from "../../hooks/useProductItemForm.ts";
import { Button } from "reactstrap";
import { useProductItemApi } from "../../hooks/useProductItemApi.ts";



export default function ProductItemForm() {
  const { control, getValues, reset, setValue } = useFormContext<ProductItem>();
  const { autoGrow } = useProductItemForm(); // 여기서는 높이 조절만

  const { insertProductItem } = useProductItemApi();

  const insertItem = async () => {
    setValue("id", crypto.randomUUID());
    const data = getValues();

    await insertProductItem(data);

    reset(defaultProductItem); // 이러면 실제로 UI도 초기화됨
  };

  return (
    <div className="p-4 space-y-4">
      <form style={styles.form}>
        <h2 style={styles.heading}>제품 입력</h2>
        <Stack spacing={4}>
          <div style={styles.grid}>
            {productItemFields.map(({ label, name, type, required, multiline }) => (
              <label
                key={name}
                style={{
                  ...styles.label,
                  ...(multiline ? styles.fullWidth : null),
                }}
              >
                {label}
                {required && <span style={styles.required}>*</span>}

                <Controller
                  name={name as keyof ProductItem}
                  control={control}
                  rules={required ? { required: true } : undefined}
                  render={({ field }) =>
                    multiline ? (
                      <textarea
                        {...field}
                        rows={5}
                        style={styles.textarea}
                        onInput={(e) => autoGrow(e.currentTarget)}
                      />
                    ) : (
                      <input
                        {...field}
                        type={type}
                        style={styles.input}
                      />
                    )
                  }
                />
              </label>
            ))}
          </div>
        </Stack>
      </form>

      <Button onClick={insertItem} style={styles.button}>
        제품 추가
      </Button>
    </div>
  );
}
